<template>
    <ul class="filter">
        <li class="filter__item" v-if="departments">
            <label for="departmentFilter" class="sr-only">{{ dictionary.EmployeesDepartments
                }}</label>
            <select id="departmentFilter" v-model="department" :disabled="isLoading">
                <option value="All">{{ dictionary.EmployeesDepartments }}</option>
                <option v-for="departmentItem in departments" :key="departmentItem.Key" :value="departmentItem.Key">{{
            departmentItem.Name
        }}</option>
            </select>
        </li>
        <li class="filter__item" v-if="hasFilterApplied">
            <button type="button" @click="resetFilter">{{ dictionary.EmployeesResetFilter }}</button>
        </li>
    </ul>
    <ul class="employees-overview__container" v-if="groupedEmployees">
        <li class="employees-overview__container-item" v-for="(group, key) in groupedEmployees" :key="key">
            <p class="employees-overview__department-name">{{ key }}</p>
            <ul class="employees-overview__list">
                <li class="employees-overview__list-item" v-for="employee in group" :key="employee.Location">
                    <div class="employees-overview__image">
                        <ResponsiveImage v-if="employee.HasImage" :imageModel="employee.ImageForVue" />
                    </div>
                    <div class="employees-overview__info">
                <li class="employees-overview__info-location">{{ employee.Title }}</li>
                <h3 class="employees-overview__info-name">{{ employee.FullName }}</h3>
                <div class="employee-item__row">
                    <p v-if="employee.HasEmail" class="employees-overview__info-email">
                        <a :href="'mailto:' + employee.Email">{{ employee.Email }}</a>
                    </p>
                    <p v-if="employee.HasPhone" class="employees-overview__info-phone">
                        <a :href="'tel:' + employee.Phone">{{ employee.Phone }}</a>
                    </p>
                    <p v-if="employee.HasLinkedInProfileURL">
                        <br/>
                        <a :href="employee.LinkedInProfileURL" target="_blank"><img src="/assets/images/linkedin.png" width="35" loading="lazy" /></a>
                    </p>
                </div>
                </div>
        </li>
    </ul>
    </li>

    </ul>
    <div class="employees__footer">
        <div class="employees__no-employees" v-show="!employees && !isLoading">
            {{ dictionary.EmployeesNoResults}}
        </div>
    </div>
</template>

<script>
import { nextTick } from 'vue'
import { bindRoute } from "./mixins/bindroute.js";
import ResponsiveImage from "./components/responsiveImage.vue";


const serviceUrl = "/umbraco/api/employeesApi/getEmployees",
    defaultDepartment = "All";

export default {
    name: "employees",
    components: {
        ResponsiveImage
    },
    data() {
        return {
            dictionary: [],
            departments: [],
            employees: [],
            locations: [],
            pageSize: 16,
            totalEmployees: 0,
            loadedEmployees: 0,
            isLoading: false,
            hasLoadedInitials: false,
            isResetting: false
        };
    },
    mixins: [
        bindRoute({
            page: 1,
            department: defaultDepartment,
        }),
    ],
    watch: {
        page: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal, false, true);
            }
        },
        department: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal, true, false);
            }
        },
    },
    mounted() {
        this.$router.isReady().then(() => {
            this.getInitialEmployees();
        }).catch(error => {
            console.log(error);
        });
    },
    methods: {
        handleFilterPropertyChange(oldVal, newVal, resetPage = false, append = false) {
            if (oldVal !== newVal) {
                if (this.hasLoadedInitials && !this.isResetting) {
                    this.filterChanged(resetPage, append);
                }
            }
        },
        getEmployees(append = false) {
            const vm = this,
                languageCode = document.querySelector("html").getAttribute("lang");
            vm.toggleSpinner(true);
            var object = {
                languageCode: languageCode,
            };

            if (vm.department != defaultDepartment) {
                object.department = vm.department;
            }

            fetch(serviceUrl + "?" + new URLSearchParams(object))
                .then((response) => response.json())
                .then((data) => {

                    if (append) {
                        vm.employees.push(...data.Items);
                        vm.loadedEmployees += data.Items.length;
                    } else {
                        vm.employees = data.Items;
                        vm.loadedEmployees = data.Items.length;
                    }
                    vm.locations = data.Locations;
                    vm.totalEmployees = data.TotalItems;

                    vm.dictionary = data.Dictionary;
                    vm.departments = data.Facets.Departments;

                    nextTick(() => {
                        vm.hasLoadedInitials = true;
                        vm.toggleSpinner(false);
                        vm.isResetting = false;
                    });

                })
                .catch((error) => {
                    console.log(error);
                    vm.toggleSpinner(false);
                });
        },
        getNextPage() {
            if (!this.isLoading) {
                this.page++;
            }
        },
        getInitialEmployees() {
            // Get all cases up to, and including, the current page
            this.getEmployees(0, this.page * this.pageSize, true);

        },
        filterChanged(resetPage = false, append = false) {
            this.isResetting = true;
            if (!append || resetPage) {
                this.page = 1;
                this.getEmployees(append);
            } else {
                this.getEmployees(append);
            }
        },
        resetFilter() {
            const vm = this;
            vm.isResetting = true;
            vm.employees = [];
            vm.totalEmployees = 0;
            vm.loadedEmployees = 0;
            vm.page = 1;
            vm.department = defaultDepartment;

            vm.$router.replace({ path: window.location.pathname })
                .then(() => {
                    vm.getEmployees();
                })
                .catch(err => { console.log(err); });
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
    },
    computed: {
        hasMoreEmployees() {
            return (
                this.totalEmployees !== 0 &&
                this.employees.length < this.totalEmployees
            );
        },
        hasFilterApplied() {
            return this.department != defaultDepartment
        },
        groupedEmployees() {
            if (this.employees) {
                const departments = this.employees.reduce((groups, item) => {
                    const group = (groups[item.DepartmentName] || []);
                    group.push(item);
                    groups[item.DepartmentName] = group;
                    return groups;
                }, {});

                //If there is departments, lets see if we need to do something with locations
                if (departments) {
                    for (const [key, value] of Object.entries(departments)) {
                        let locations = [];

                        //Get all locations for the department
                        value.forEach(item => {
                            if (item.HasLocations) {
                                locations.push(...item.Locations);
                            }
                        });

                        //If there is locations, get them and create new departments
                        if (locations.length > 0) {
                            locations = locations.filter((value, index) => locations.indexOf(value) === index);

                            locations.forEach(location => {
                                const departmentName = key + ' ' + location;
                                departments[departmentName] = value.filter(x => x.HasLocations && x.Locations.indexOf(location) > -1);
                            });

                            //Remove the original department
                            delete departments[key];
                        }
                    }
                }


                //Now we need to sort the departments again
                const departmentsArray = Object.entries(departments);
                const getOrderIndex = (array, value) => array.findIndex(x=>value.includes(x));
                departmentsArray.sort(([aKey,aVal],[bKey,bVal]) => {
                    const nameIndexA = getOrderIndex(this.departments.map(x=>x.Name), aKey);
                    const nameIndexB = getOrderIndex(this.departments.map(x=>x.Name), bKey);

                    if (nameIndexA === nameIndexB) {
                        const locationIndexA = getOrderIndex(this.locations, aKey);
                        const locationIndexB = getOrderIndex(this.locations,bKey);
                        return locationIndexA - locationIndexB;
                    }

                    return nameIndexA - nameIndexB;
                });

                return Object.fromEntries(departmentsArray);;
            }
            return null;
        },
    },
};
</script>